module.exports = __webpack_public_path__ + "img/overview.bfc13c09.jpg";